const productSearch = {
  filters: {
    label: 'Filter',
    filterBy: 'Filter by',
    resetToDefault: 'Clear filters',
    selectedFilters: 'Selected filters',
    items: {
      categories: 'Categories',
      producers: 'Manufacturers',
      showAll: 'Show all',
    },
    modal: {
      productFilter: 'Product search filter',
      apply: 'Apply',
    },
  },
  sort: {
    productName: 'Product name',
    popularity: 'Popularity',
    sort: 'sort',
    disabedSort: 'Disabled sort',
  },
  yourSearchResultsFor: 'Your search results for',
  allProducts: 'All products',
  monthProductsOffer: 'Products of the month',
  productsOffer: 'Our offers',
  showAllProducts: 'View all products',
  warning: {
    title: 'Products with this note are currently only available to a limited extent',
    text: 'You can request the products from your pharmacy.',
  },
  noResults: {
    searchTerm: {
      title: ' Ooops! Your search for {searchTerm} did not return any results',
      tipsText: 'Tips to help you find your desired product:',
      tips: {
        0: 'Search specifically for product names, product categories and PZN.',
        1: 'Check whether a typo has crept in (e.g. "Apsirin" instead of "Aspirin").',
        2: 'Short search terms increase the number of hits (e.g. "headache" instead of "severe headache").',
        3: 'This product may not be available in the range of your selected pharmacy. Look for alternatives or change your pharmacy.',
      },
      toShop: 'To the shop page',
    },
    filters: {
      noProductsFound: 'No products were found for your filter settings.',
      adjustSearch: 'Please adjust your search.',
    },
  },
}

export default productSearch
